export default "__VITE_ASSET__Duto233h__"